import {
  Create,
  SimpleForm
} from 'react-admin';
import {
  hasValue
} from "../../utils/schemas";
import * as Yup from "yup";
import { Grid } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomRichTextInput from '../../ui/custom-rich-text-input';
import CustomSaveToolbar from "../../ui/custom-save-toolbar";

const Schema = Yup.object(
{
  text: hasValue()
});

const TermsOfUseCreate = () =>
{
  return (
    <Create
      title="Novo Termo de Uso"
      redirect="list">
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={ <CustomSaveToolbar /> }>
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 6 }}>
            <CustomRichTextInput source="text" label="Texto" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Create>
  )
}

export default TermsOfUseCreate;
